import React from 'react'
import { UseFormRegister, FieldErrors } from 'react-hook-form'
import { formatPhoneNumber } from '../../../../utils'
import { StorageFormValues } from '../config/validationSchema'

interface EmergencyContactStepProps {
  register: UseFormRegister<StorageFormValues>
  errors: FieldErrors<StorageFormValues>
}

const EmergencyContactStep: React.FC<EmergencyContactStepProps> = ({
  register,
  errors
}) => {
  return (
    <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
      <div style={{ marginBottom: '1.5rem' }}>
        <label htmlFor="emergency_contact_name" className="forceBlack">Emergency Contact</label>
        <input
          id="emergency_contact_name"
          placeholder="Emergency contact name"
          type="text"
          {...register('emergency_contact_name')}
          className={errors.emergency_contact_name ? 'text-input error' : 'text-input'}
        />
        {errors.emergency_contact_name && <div className="input-feedback">{errors.emergency_contact_name.message}</div>}
      </div>

      <div style={{ marginBottom: '1.5rem' }}>
        <label htmlFor="emergency_contact_phone" className="forceBlack">Emergency Phone</label>
        <input
          id="emergency_contact_phone"
          placeholder="Emergency phone #"
          type="text"
          maxLength={14}
          {...register('emergency_contact_phone', {
            onChange: (e) => {
              e.target.value = formatPhoneNumber(e.target.value)
            }
          })}
          className={errors.emergency_contact_phone ? 'text-input error' : 'text-input'}
        />
        {errors.emergency_contact_phone && <div className="input-feedback">{errors.emergency_contact_phone.message}</div>}
      </div>

      <div style={{ marginBottom: '1.5rem' }}>
        <label htmlFor="business_name" className="forceBlack">
          Business Name <span style={{ fontSize: 14 }}>(optional)</span>
        </label>
        <input
          id="business_name"
          placeholder="Business Name"
          type="text"
          {...register('business_name')}
          className="text-input"
        />
      </div>
    </div>
  )
}

export default EmergencyContactStep
